import { render, staticRenderFns } from "./EventiPrestazioniComponent.vue?vue&type=template&id=c3b4aacc"
import script from "./EventiPrestazioniComponent.vue?vue&type=script&lang=js"
export * from "./EventiPrestazioniComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiPrestazioniComponent.vue?vue&type=style&index=0&id=c3b4aacc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports